import { RowInfo } from '@varo/graphql-schema-types';
import { IconAvatarProps } from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import { illustrationKeyForStyleDictionary } from 'shared/components/vxl/Illustration/Illustration.helpers';
import { ListItemProps } from 'shared/components/vxl/ListItem/ListItem';
import { ListItemLeadingAccessoryProps } from 'shared/components/vxl/ListItem/ListItemLeadingAccessory';
import { ListItemTrailingAccessoryProps } from 'shared/components/vxl/ListItem/ListItemTrailingAccessory';
import { VXLComponentId } from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

import bottomSheetElementResults from './bottomSheetElementResult';
import { BorrowingPowerDependencies } from './types';

export default function rowInfo(
  rowItem: RowInfo,
  dependencies: BorrowingPowerDependencies,
): ListItemProps {
  const trailingAccessory: Maybe<ListItemTrailingAccessoryProps> =
    rowItem.primaryTextV2 || rowItem.secondaryText
      ? {
          id: 'row-item-trailing-accessory' + rowItem.id,
          name: VXLComponentId.LIST_ITEM_TEXT_STACK,
          props: {
            primaryCopy: rowItem.primaryTextV2?.copy || '',
            secondaryCopy: rowItem.secondaryText?.copy || '',
          },
        }
      : null;

  const illustrationKey = rowItem.image
    ? illustrationKeyForStyleDictionary(rowItem.image)
    : null;
  const leadingAccessory: Maybe<ListItemLeadingAccessoryProps> = illustrationKey
    ? {
        id: 'row-item-leading-accessory' + rowItem.id,
        name: VXLComponentId.ICON_AVATAR,
        props: {
          variant: 'LG',
          illustrationKey,
        } satisfies IconAvatarProps,
      }
    : null;

  return {
    primaryCopy: rowItem.rowInfoTitle.copy || '',
    secondaryCopy: rowItem.footnoteText?.copy || '',
    trailingAccessory,
    leadingAccessory,
    isDisabled: false,
    showsChevron: !(rowItem.onClick === null),
    trailingAccessoryContainerStyle: {
      flexShrink: 0,
    },
    onPress: () => {
      dependencies.showBottomSheet(
        bottomSheetElementResults(rowItem.onClick?.elements, dependencies),
      );
    },
  };
}
